<template>
  <div>
    <div id="csvLinkContainer"></div>
    <v-card :loading="isLoading">
      <v-card-title>
        Editions de cartes
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="openAffectDialog = true">
          <v-icon>mdi-folder-account</v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="openCreateDialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div id="table-editions-container">
          <base-data-table
            :items="editions.data"
            :serverItemsLength="editions.total"
            :nbItemsByPage="NB_ITEMS_BY_PAGE"
            :loading="isLoading"
            :options.sync="options"
            :headers="headers"
            containerId="#table-editions-container"
            :fixedHeaders="true"
            class="table-cursor"
            itemClickRouterTarget="card-editions-details"
          >
            <template v-slot:item.updatedAt="{ item }">
              {{ getInternationalDate(item.updatedAt) }}
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ getInternationalDate(item.createdAt) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                color="green"
                @click="exportEditionAsExcel(item.id)"
                :loading="loadingExport"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
              <v-btn icon @click.stop="assignEditionToDelete(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </base-data-table>
        </div>
      </v-card-text>
    </v-card>
    <create-edit-card-edition
      :open.sync="openCreateDialog"
      v-if="openCreateDialog"
      :editMode="false"
    ></create-edit-card-edition>
    <affect-client-cards-dialog
      :open.sync="openAffectDialog"
      v-if="openAffectDialog"
    ></affect-client-cards-dialog>
    <delete-dialog
      :open.sync="openDeleteDialog"
      v-on:delete="triggerEditionDelete()"
    >
      <template #title> Suppression édition de cartes </template>
      Vous êtes sur le point de supprimer cette édition de cartes. Voulez-vous
      continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { defineComponent, toRefs, onMounted, ref } from "@vue/composition-api";
import { useCardEdition } from "@/composables/cards-edition";
import { useTitle } from "@/composables/title";
import BaseDataTable from "@/components/General/BaseDataTable.vue";
import CreateEditCardEdition from "@/components/CardEdition/CreateEditCardEditionDialog.vue";
import AffectClientCardsDialog from "@/components/CardEdition/AffectClientCardsDialog.vue";
import { date } from "@/composables/date";
import DeleteDialog from "../components/General/DeleteDialog.vue";

export default defineComponent({
  components: {
    BaseDataTable,
    CreateEditCardEdition,
    AffectClientCardsDialog,
    DeleteDialog,
  },
  setup() {
    /* Import des API */
    const {
      editions,
      editionData,
      listCardEditions,
      currentEdition,
      deleteCardEdition,
      exportEdition,
    } = useCardEdition();
    const { setTitle, setIcon } = useTitle();
    const { getInternationalDate } = date();

    /* Cycle de vie */
    onMounted(async () => {
      setIcon("mdi-card-plus");
      setTitle("Editions de cartes");
      await listCardEditions();
    });

    /* Variables */
    const headers = [
      { text: "Commentaire", value: "comment" },
      { text: "Créée le", value: "createdAt" },
      { text: "Par", value: "createdBy" },
      { text: "Modifié le", value: "updatedAt" },
      { text: "Par", value: "updatedBy" },
      { text: "", value: "actions" },
    ];
    const NB_ITEMS_BY_PAGE = 100;
    const openDeleteDialog = ref(false);
    const loadingExport = ref(false);

    /* Méthodes */
    const assignEditionToDelete = function (edition) {
      currentEdition.value = edition;
      openDeleteDialog.value = true;
    };
    const triggerEditionDelete = async function () {
      openDeleteDialog.value = false;
      editionData.isLoading = true;
      await deleteCardEdition();
      await listCardEditions();
    };
    const exportEditionAsExcel = async function (id) {
      loadingExport.value = true;
      await exportEdition(id);
      loadingExport.value = false;
    };

    return {
      editions,
      ...toRefs(editionData),
      headers,
      NB_ITEMS_BY_PAGE,
      getInternationalDate,
      assignEditionToDelete,
      openDeleteDialog,
      currentEdition,
      triggerEditionDelete,
      exportEditionAsExcel,
      loadingExport,
    };
  },
});
</script>
